import { AppShell } from '@/components/layout/AppShell';
import { AnalyticsDashboard } from '@/components/analytics/AnalyticsDashboard';
import { rxkModuleIcon, rxkModuleTitle, rxkNavGroups } from '../nav';

export default function AdminAnalytics() {
  return (
    <AppShell moduleTitle={rxkModuleTitle} moduleIcon={rxkModuleIcon} navGroups={rxkNavGroups}>
      <div className="mb-5">
        <h1 className="text-[22px] font-bold text-ink">Analytics</h1>
        <p className="text-[13px] text-ink-faint">Who visits Rx.K Seoul, where they come from (Facebook, Instagram, Google, our links…), what they look at and what they order.</p>
      </div>
      <AnalyticsDashboard sites={['rxk']} />
    </AppShell>
  );
}
